const SaveToDraft = (state = false, action) => {
    switch (action.type) {
        case 'MuftiSavetoDraft_SUCCESS':
            return true
        case 'MuftiSavetoDraft_Reset':
            return false
        default:
            return state
    }
}
export default SaveToDraft